"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyAlertPlaceholder = exports.alertListSelectedStyle = exports.alertDetailItemStyle = exports.alertListDetailTextStyle = exports.alertListDetailStyle = exports.alertUnOrderListStyle = exports.alertListHeaderStyle = exports.alertListItemStyle = exports.alertListStatusStyle = exports.alertListTextStyle = exports.alertListDetailContainerStyle = exports.alertListStatusContainerStyle = exports.alertListRecommendationContainerStyle = exports.alertContainerStyle = exports.alertDisparateImpactTitle = exports.alertDataLeakageCriteriaList = exports.alertDataLeakageText = exports.recommendedBucketStyle = exports.alertSuggestedBucketsUnOrderList = exports.alertCollinearFootNote = exports.acceptedAlertNumber = exports.ignoredAlertNumber = exports.recommendedAlertNumber = exports.alertQualityCheckIcon = exports.alertSummaryDetailText = exports.alertSummaryDetail = exports.alertSummaryDetailBorder = exports.alertSummaryDescription = exports.alertSummaryHeader = exports.alertSummaryContainer = exports.alertBorder = void 0;
var typestyle_1 = require("typestyle");
var colors = require("../util/colors");
require("@tableau/fonts-tableau");
/**
 * Layout specific CSS variables
 */
var ALERT_LIST_RECOMMENDED_WIDTH = 400;
// TODO: post alpha status column
var ALERT_LIST_STATUS_WIDTH = 150;
var ALERT_LIST_DETAIL_WIDTH = 517;
var ALERT_LIST_CONTAINER_WIDTH = ALERT_LIST_RECOMMENDED_WIDTH + ALERT_LIST_DETAIL_WIDTH;
var ALERT_SUMMARY_WIDTH = 377;
var GENERAL_PADDING = '16px';
/**
 * Border specific CSS variables
 */
exports.alertBorder = typestyle_1.style({
    border: '1px solid ' + colors.tableauGray05,
    borderRadius: '2px',
    boxSizing: 'border-box',
});
/**
 * Font specific CSS variables
 */
var FONT_WEIGHT_REGULAR = 350;
var FONT_SIZE_LARGE = '18px';
var FONT_SIZE_REGULAR = '12px';
/**
 * Alert Summary Component
 */
exports.alertSummaryContainer = typestyle_1.style({
    display: 'flex',
    flexDirection: 'column',
    width: ALERT_SUMMARY_WIDTH,
    background: colors.white,
});
exports.alertSummaryHeader = typestyle_1.style({
    fontWeight: FONT_WEIGHT_REGULAR,
    fontSize: FONT_SIZE_LARGE,
    fontStyle: 'normal',
    lineHeight: '27px',
    padding: '12px 12px 0 12px',
    letterSpacing: '0.2px',
});
exports.alertSummaryDescription = typestyle_1.style({
    fontWeight: FONT_WEIGHT_REGULAR,
    fontSize: FONT_SIZE_REGULAR,
    letterSpacing: '0.2px',
    fontStyle: 'normal',
    lineHeight: '18px',
    padding: GENERAL_PADDING,
});
exports.alertSummaryDetailBorder = typestyle_1.style({
    borderBottom: '1px solid ' + colors.tableauGray05,
});
exports.alertSummaryDetail = typestyle_1.style({
    display: 'flex',
    flexDirection: 'row',
    padding: '16px 0',
    margin: '0 16px',
});
exports.alertSummaryDetailText = typestyle_1.style({
    fontStyle: 'normal',
    fontWeight: FONT_WEIGHT_REGULAR,
    fontSize: FONT_SIZE_REGULAR,
    letterSpacing: '0.2px',
    lineHeight: '12px',
    paddingLeft: '12px',
});
var numberIconCommon = {
    width: '24px',
    fontSize: FONT_SIZE_REGULAR,
    lineHeight: '12px',
    fontWeight: FONT_WEIGHT_REGULAR,
    letterSpacing: '0.2px',
};
exports.alertQualityCheckIcon = typestyle_1.style(__assign(__assign({}, numberIconCommon), { textAlign: 'center' }));
exports.recommendedAlertNumber = typestyle_1.style(__assign(__assign({}, numberIconCommon), { textAlign: 'center', color: colors.brandOrange, backgroundColor: colors.warningLight, height: '12px', padding: '2px 0' }));
exports.ignoredAlertNumber = typestyle_1.style(__assign(__assign({}, numberIconCommon), { textAlign: 'center', color: colors.lightWeightBlue, backgroundColor: colors.infoLight, height: '12px', padding: '2px 0' }));
exports.acceptedAlertNumber = typestyle_1.style(__assign(__assign({}, numberIconCommon), { textAlign: 'center', color: colors.successGlobal, backgroundColor: colors.successLight, height: '12px', padding: '2px 0' }));
/*
 * Alert Detail Component
 */
var alertDetailTextCommon = {
    fontSize: FONT_SIZE_REGULAR,
    fontWeight: FONT_WEIGHT_REGULAR,
    lineHeight: '18px',
};
exports.alertCollinearFootNote = typestyle_1.style(__assign(__assign({}, alertDetailTextCommon), { textAlign: 'right', marginRight: '40px', paddingTop: GENERAL_PADDING, lineHeight: '11px' }));
exports.alertSuggestedBucketsUnOrderList = typestyle_1.style(__assign(__assign({}, alertDetailTextCommon), { listStyle: 'none', padding: '5px 0 0 32px' }));
exports.recommendedBucketStyle = typestyle_1.style({
    marginTop: '4px',
});
exports.alertDataLeakageText = typestyle_1.style(__assign(__assign({}, alertDetailTextCommon), { padding: '5px 0 0 32px' }));
exports.alertDataLeakageCriteriaList = typestyle_1.style({
    listStyle: 'none',
    paddingLeft: GENERAL_PADDING,
});
exports.alertDisparateImpactTitle = typestyle_1.style(__assign({}, alertDetailTextCommon));
/*
 * Alert List Component
 */
exports.alertContainerStyle = typestyle_1.style({
    display: 'flex',
    width: ALERT_LIST_CONTAINER_WIDTH,
    backgroundColor: colors.tableauGray04,
});
exports.alertListRecommendationContainerStyle = typestyle_1.style({
    width: ALERT_LIST_RECOMMENDED_WIDTH,
    display: 'flex',
    flexDirection: 'column',
});
exports.alertListStatusContainerStyle = typestyle_1.style({
    width: ALERT_LIST_STATUS_WIDTH,
});
exports.alertListDetailContainerStyle = typestyle_1.style({
    width: ALERT_LIST_DETAIL_WIDTH,
    backgroundColor: colors.white,
});
var alertListTextBasic = {
    fontSize: '14px',
    fontWeight: FONT_WEIGHT_REGULAR,
    lineHeight: '21px',
};
var alertListBodyCommon = __assign(__assign({}, alertListTextBasic), { color: colors.tableauGray11, backgroundColor: colors.tableauGray03, cursor: 'pointer', height: '21px', boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.1)' });
exports.alertListTextStyle = typestyle_1.style(__assign(__assign({}, alertListBodyCommon), { padding: GENERAL_PADDING, display: 'flex', flexDirection: 'row', alignItems: 'stretch', $nest: {
        '& > div': {
            flex: 1,
        },
        '& > div:last-child': {
            fontWeight: 'bold',
            textAlign: 'right',
        },
    } }));
exports.alertListStatusStyle = typestyle_1.style(__assign(__assign({}, alertListBodyCommon), { padding: '16px 0' }));
exports.alertListItemStyle = typestyle_1.style({
    overflow: 'auto',
});
exports.alertListHeaderStyle = typestyle_1.style(__assign(__assign({}, alertListTextBasic), { height: '21px', padding: GENERAL_PADDING, color: colors.tableauGray11, background: colors.white, borderBottom: '1px solid ' + colors.tableauGray06 }));
exports.alertUnOrderListStyle = typestyle_1.style({
    padding: 0,
    margin: 0,
});
exports.alertListDetailStyle = typestyle_1.style({
    listStyle: 'none',
    color: colors.tableauGray11,
    borderBottom: '1px solid ' + colors.tableauGray09,
    paddingBottom: GENERAL_PADDING,
});
exports.alertListDetailTextStyle = typestyle_1.style(__assign(__assign({}, alertDetailTextCommon), { padding: '16px 16px 0 16px' }));
exports.alertDetailItemStyle = typestyle_1.style({
    overflowY: 'auto',
    position: 'relative',
});
exports.alertListSelectedStyle = typestyle_1.style({
    backgroundColor: colors.white,
    cursor: 'initial',
});
exports.emptyAlertPlaceholder = typestyle_1.style(__assign(__assign({}, alertListTextBasic), { margin: 'auto' }));
//# sourceMappingURL=DataAlerts.js.map